export default __webpack_public_path__ + "static/error_img-94482c42f1d21a6fb55260451e9b3f62.jpg";